import request from '@utils/request'

export function createMember(data) {
  return request.post('/member', data)
}

export function fetchMember(member_seq) {
  return request.get(`/member/${member_seq}`)
}

export function fetchSelf() {
  return request.get('/member/me')
}
export function updateMember(data) {
  return request.put(`/member/me`, data)
}

export function deleteMember(data) {
  return request({
    url: `/member/me`,
    method: 'delete',
    data,
  })
}

export function updateMemberPassword(data) {
  return request({
    url: `/member/me`,
    method: 'patch',
    data: {
      ...data,
      type: 'UPDATE_PASSWORD',
    },
  })
}

export function updateMemberEmail(data) {
  return request({
    url: `/member/me`,
    method: 'patch',
    data: {
      ...data,
      type: 'UPDATE_EMAIL_ADDRESS',
    },
  })
}
